/* custom-bureau-v2-varianten.js — pure variantlogica voor de bureau-v2-PDP.
   Geen DOM. Getest met node --test tests/bureau-v2/varianten.test.mjs. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.BureauV2Varianten = api;
})(typeof self !== 'undefined' ? self : this, function () {
  function maakSleutel(opties) { return opties.join(''); }

  function bouwMatrix(varianten) {
    var m = new Map();
    varianten.forEach(function (v) { m.set(maakSleutel(v.opties), v); });
    return m;
  }

  function vindVariant(matrix, selectie) { return matrix.get(maakSleutel(selectie)) || null; }

  /* "120 x 60 cm" → "120x60"; zelfde sleutel voor configurator- en bundelmaten */
  function normMaat(s) { return String(s).toLowerCase().replace(/×/g, 'x').replace(/[^0-9x]/g, ''); }
  function oppervlak(s) { var d = normMaat(s).split('x').map(Number); return (d[0] || 0) * (d[1] || 0); }

  function waardenVan(data, i) {
    var w;
    if (data.waarden) w = data.waarden[i].slice();
    else { w = []; data.varianten.forEach(function (v) { if (w.indexOf(v.opties[i]) === -1) w.push(v.opties[i]); }); }
    /* Shopify zet 120x60 achteraan; toon maten klein → groot (design) */
    if (i === data.maatIndex) w.sort(function (a, b) { return oppervlak(a) - oppervlak(b) || normMaat(a).localeCompare(normMaat(b)); });
    return w;
  }

  function volgorde(data) {
    if (data.volgorde) return data.volgorde.slice();
    var blad = -1, frame = -1;
    data.opties.forEach(function (n, k) { if (/blad/i.test(n)) blad = k; else if (/frame/i.test(n)) frame = k; });
    var vo = [blad, frame, data.maatIndex].filter(function (k) { return k >= 0; });
    data.opties.forEach(function (_, k) { if (vo.indexOf(k) === -1) vo.splice(vo.length - 1, 0, k); });
    return vo;
  }

  function bovenVan(data, i) { var vo = volgorde(data); return vo.slice(0, vo.indexOf(i)); }

  function past(v, selectie, indexen) {
    return indexen.every(function (k) { return v.opties[k] === selectie[k]; });
  }

  function uitlegVoor(data, selectie, i, waarde) {
    var mi = data.maatIndex, boven = bovenVan(data, i).concat(i === mi ? [] : [i]);
    var sel = selectie.slice(); sel[i] = waarde;
    var maten = waardenVan(data, mi);
    for (var k = 0; k < maten.length; k++) {
      var ok = data.varianten.some(function (v) { return v.opties[mi] === maten[k] && past(v, sel, boven.filter(function (x) { return x !== mi; })); });
      if (ok) return 'Deze combinatie is er vanaf ' + maten[k];
    }
    return 'Deze combinatie is niet leverbaar';
  }

  function beschikbaarheid(data, matrix, selectie, i) {
    var boven = bovenVan(data, i);
    return waardenVan(data, i).map(function (waarde) {
      var bestaat = data.varianten.some(function (v) { return v.opties[i] === waarde && past(v, selectie, boven); });
      return { waarde: waarde, bestaat: bestaat, uitleg: bestaat ? '' : uitlegVoor(data, selectie, i, waarde) };
    });
  }

  function dichtstbijzijnde(data, matrix, selectie, i, waarde) {
    var exact = selectie.slice(); exact[i] = waarde;
    var direct = vindVariant(matrix, exact); if (direct) return direct;
    var vast = bovenVan(data, i), best = null, bestScore = -1;
    data.varianten.forEach(function (v) {
      if (v.opties[i] !== waarde || !past(v, selectie, vast)) return;
      var score = 0;
      for (var k = 0; k < selectie.length; k++) if (k !== i && vast.indexOf(k) === -1 && v.opties[k] === selectie[k]) score++;
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  function bespaar(v) {
    if (!v || v.compare == null || v.compare <= v.prijs) return null;
    var bedrag = v.compare - v.prijs;
    return { bedrag: bedrag, procent: Math.floor((bedrag / v.compare) * 100) };
  }

  /* R-4 (orchestrator, bindend — vervangt SPEC/brief-tekst): bundelKeuze matcht op
     blad + maat (SPEC §4). Frame filtert niet mee; frame is uitsluitend een
     tiebreaker als meerdere bundels met dezelfde titel + blad allebei passen —
     dan wint de bundel wiens frame de selectie matcht. */
  function bundelKeuze(bundels, selectie, data) {
    var bladI = 1, frameI = 2, mi = data.maatIndex;
    data.opties.forEach(function (n, k) {
      if (/blad/i.test(n)) bladI = k; else if (/frame/i.test(n)) frameI = k;
    });
    var kandidaten = [];
    (bundels || []).forEach(function (b) {
      if (b.blad !== selectie[bladI]) return;
      var maatMatch = b.varianten.filter(function (x) { return normMaat(x.maat) === normMaat(selectie[mi]); });
      if (!maatMatch.length) return;
      /* Bevinding 5 (eindreview): het bundelPRODUCT kan voor dezelfde maat meerdere varianten
         hebben (een eigen Kleur Frame-optie, evt. + zitting) — [0] pakken was willekeurig en
         kon zo een ander frame verkopen dan net gekozen, zonder dat de kaart dat liet zien.
         Vind de bundel-eigen frame-optie-index (zelfde /frame/i-heuristiek als hierboven) en
         prefereer een variant die matcht op de GEKOZEN framekleur; anders de goedkoopste — en
         onthoud wát er precies gekozen is, zodat de kaart dat eerlijk kan tonen. */
      var bFrameI = -1;
      (b.optienamen || []).forEach(function (n, k) { if (/frame/i.test(n)) bFrameI = k; });
      var bv;
      if (bFrameI >= 0) {
        var framePassend = maatMatch.filter(function (x) { return x.opties && x.opties[bFrameI] === selectie[frameI]; });
        bv = framePassend.length ? framePassend[0] : maatMatch.slice().sort(function (a, c) { return a.prijs - c.prijs; })[0];
      } else if (maatMatch.length > 1) {
        bv = maatMatch.slice().sort(function (a, c) { return a.prijs - c.prijs; })[0];
      } else {
        bv = maatMatch[0];
      }
      var kenmerk = { frame: bFrameI >= 0 && bv.opties ? bv.opties[bFrameI] : '', extra: '' };
      if (bv.opties) {
        var overig = bv.opties.filter(function (w, k) { return k !== bFrameI && normMaat(w) !== normMaat(bv.maat); });
        kenmerk.extra = overig.join(' · ');
      }
      kandidaten.push({ bundel: b, variant: bv, bespaar: bespaar(bv), kenmerk: kenmerk });
    });
    var groepen = {};
    kandidaten.forEach(function (k) {
      var sleutel = k.bundel.titel + '|' + k.bundel.blad;
      (groepen[sleutel] = groepen[sleutel] || []).push(k);
    });
    var uit = [];
    Object.keys(groepen).forEach(function (sleutel) {
      var groep = groepen[sleutel];
      if (groep.length > 1) {
        var passend = groep.filter(function (k) { return k.bundel.frame === selectie[frameI]; });
        uit.push.apply(uit, passend.length ? passend : groep);
      } else {
        uit.push.apply(uit, groep);
      }
    });
    return uit;
  }

  /* fase 4 J36: de échte losse som = bureauvariant (maat + blad + frame van de bundel) + stoelvariant
     (zitting van de bundelvariant). Nooit de compare-at van de bundel (SPEC §2, eerlijkheidsregel). */
  function losseSom(data, bundel, variant) {
    var mi = data.maatIndex, bladI = -1, frameI = -1;
    data.opties.forEach(function (n, k) { if (/blad/i.test(n)) bladI = k; else if (/frame/i.test(n)) frameI = k; });
    var bureau = null;
    data.varianten.forEach(function (v) {
      if (bureau) return;
      if (normMaat(v.opties[mi]) !== normMaat(variant.maat)) return;
      if (bladI >= 0 && v.opties[bladI] !== bundel.blad) return;
      if (frameI >= 0 && bundel.frame && v.opties[frameI] !== bundel.frame) return;
      bureau = v;
    });
    if (!bureau || !bundel.stoel || !bundel.stoel.varianten || !bundel.stoel.varianten.length) return null;
    var zitting = bundel.zittingIndex >= 0 && variant.opties ? variant.opties[bundel.zittingIndex] : '';
    var stoel = null;
    bundel.stoel.varianten.forEach(function (s) { if (!stoel && (s.zitting === zitting || (!zitting && !s.zitting))) stoel = s; });
    /* eindfix 3: een zitting zonder stoelvariant = geen eerlijke losse som (vroeger stil variant[0], dus
       een "los"-bedrag met de prijs van een andere zitting). Alleen zonder zitting (bundel zonder
       zittingoptie) blijft de enige/eerste stoelvariant de stoelprijs. */
    if (!stoel && zitting) return null;
    if (!stoel) stoel = bundel.stoel.varianten[0];
    return { bureau: bureau.prijs, stoel: stoel.prijs, totaal: bureau.prijs + stoel.prijs };
  }

  /* ---------- fase 5 J45: set-kaart (stoel + bureau) ---------- */
  function matenOpOppervlak(maten) {
    return maten.slice().sort(function (a, b) { return oppervlak(a) - oppervlak(b) || String(a).localeCompare(String(b)); });
  }
  function setStoelen(data) {
    var uit = [], idx = Object.create(null);
    (data.bundels || []).forEach(function (b) {
      var naam = b.stoelNaam || b.titel;
      if (idx[naam] === undefined) { idx[naam] = uit.length; uit.push({ stoelNaam: naam, bundels: [], vanaf: null, label: '', zittingen: [], beeld: (b.stoel && b.stoel.beeld) || b.beeld || null,
        /* eindfix 6: 80 w voor de 32 px-mini en de 40 px-lijstopties; terugval = het gewone beeld */
        beeldKlein: (b.stoel && (b.stoel.beeldKlein || b.stoel.beeld)) || b.beeld || null }); }
      var s = uit[idx[naam]];
      s.bundels.push(b);
      if (b.label && !s.label) s.label = b.label;
      (b.varianten || []).forEach(function (v) {
        if (s.vanaf === null || v.prijs < s.vanaf) s.vanaf = v.prijs;
        if (b.zittingIndex >= 0 && v.opties) { var z = v.opties[b.zittingIndex]; if (z && s.zittingen.indexOf(z) === -1) s.zittingen.push(z); }
      });
    });
    return uit.filter(function (s) { return s.vanaf !== null; }).sort(function (a, b) { return a.vanaf - b.vanaf; });
  }
  function setBladen(stoel) { var u = []; stoel.bundels.forEach(function (b) { if (u.indexOf(b.blad) === -1) u.push(b.blad); }); return u; }
  function setBundel(stoel, blad) { var hit = null; stoel.bundels.forEach(function (b) { if (!hit && b.blad === blad) hit = b; }); return hit || stoel.bundels[0]; }
  function setMaten(bundel) { var u = []; (bundel.varianten || []).forEach(function (v) { if (u.indexOf(v.maat) === -1) u.push(v.maat); }); return matenOpOppervlak(u); }
  function setBureauStart(data, selectie, stoel, standaardMaat) {
    var bladI = -1; data.opties.forEach(function (n, k) { if (/blad/i.test(n)) bladI = k; });
    var bladen = setBladen(stoel), blad = bladI >= 0 ? selectie[bladI] : bladen[0];
    if (bladen.indexOf(blad) === -1) blad = bladen[0];
    var maten = setMaten(setBundel(stoel, blad)), zoek = function (m) { var h = null; maten.forEach(function (x) { if (!h && normMaat(x) === normMaat(m)) h = x; }); return h; };
    return { blad: blad, maat: zoek(selectie[data.maatIndex]) || zoek(standaardMaat) || maten[0] };
  }
  function setVariant(stoel, keuze) {
    var b = setBundel(stoel, keuze.blad), hit = null;
    (b.varianten || []).forEach(function (v) {
      if (hit || normMaat(v.maat) !== normMaat(keuze.maat)) return;
      if (b.zittingIndex >= 0 && v.opties[b.zittingIndex] !== keuze.zitting) return;
      hit = v;
    });
    return hit ? { bundel: b, variant: hit } : null;
  }
  function setPrijs(data, stoel, keuze, aantal) {
    var sv = setVariant(stoel, keuze); if (!sv) return null;
    var n = Math.floor(Number(aantal)); if (!(n >= 1)) n = 1;
    var som = losseSom(data, sv.bundel, sv.variant), set = sv.variant.prijs * n;
    var los = som && som.totaal > sv.variant.prijs ? som.totaal * n : null;
    return { id: sv.variant.id, set: set, los: los, bespaar: los === null ? 0 : los - set, aantal: n };
  }

  /* eindfix 7: één normalisatie voor filter- en hero-sleutels: lowercase, whitespace samengevouwen, trim.
     De Liquid (koopblok hero_hoort) doet hetzelfde met `| downcase | split: ' ' | join: ' '`. */
  function normSleutel(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim(); }

  /* fase 6 J58: welke galerijslides zijn zichtbaar, en welke is het hoofdbeeld (index [0]).
     De hero (vast) hoort alleen bij zijn eigen blad + frame; leeg heroSleutel = altijd vooraan.
     Geen match = alle niet-vaste slides (nooit leeg, nooit alleen de hero).
     eindfix 7: `kleur` = "<blad> + <frame>" van de selectie; de hero hoort erbij als
     normSleutel(kleur) === normSleutel(heroSleutel) — exact, zoals de Liquid (vroeger een achtervoegsel-
     match op de hele sleutel, waardoor bijv. heroSleutel "zwart" ook "eiken + zwart" pakte). */
  function galerijKeuze(slides, sleutel, heroSleutel, kleur) {
    var norm = normSleutel;
    var k = norm(sleutel), h = norm(heroSleutel), hero = [], rest = [], hit = [];
    slides.forEach(function (s, i) {
      if (s.vast) { hero.push(i); return; }
      rest.push(i);
      var delen = norm(s.alt).split(',').map(norm);
      if (delen.indexOf(k) !== -1) hit.push(i);
    });
    if (!hit.length) return rest;
    var heroHoort = !h || norm(kleur) === h;
    return (heroHoort ? hero : []).concat(hit);
  }

  /* fase 6 J63: hoogste echte besparing (%) over alle setvarianten — alleen uit prijzen, geen vast getal. */
  function maxBespaarProcent(data, stoelen) {
    var maxP = 0;
    (stoelen || []).forEach(function (s) { s.bundels.forEach(function (b) { (b.varianten || []).forEach(function (v) {
      var som = losseSom(data, b, v);
      if (som && som.totaal > v.prijs) maxP = Math.max(maxP, Math.floor((som.totaal - v.prijs) / som.totaal * 100));
    }); }); });
    return maxP;
  }
  /* eindfix 1: set-kaartbeelden op de gemeten vakmaat. `url` = een Shopify image_url (…&width=N);
     de breedte wordt de kleinste trede ≥ css-breedte × factor (1 = 1x-bron, 2 = 2x-bron). Treden lopen
     met ≤ 1,2× op, dus de opgevraagde breedte blijft ≤ 1,25× de weergave × DPR, en het aantal CDN-varianten
     blijft klein. Geen width-parameter of geen vakmaat (verborgen vak) → null (aanroeper houdt de bron). */
  var TREDEN = [160, 190, 230, 280, 340, 410, 490, 590, 710, 850, 1020, 1230, 1480];
  function beeldOpMaat(url, css, factor) {
    if (!url || !(css > 0) || !/[?&]width=\d+/.test(url)) return null;
    var nodig = Math.ceil(css * (factor || 1)), w = TREDEN[TREDEN.length - 1];
    for (var i = 0; i < TREDEN.length; i++) if (TREDEN[i] >= nodig) { w = TREDEN[i]; break; }
    return String(url).replace(/([?&]width=)\d+/, '$1' + w);
  }

  /* fase 6 J62: "[accent]…[/accent]" → delen; de DOM-bouw doet textContent per deel (geen innerHTML). */
  function accentDelen(t) {
    t = String(t || ''); var a = t.indexOf('[accent]'), z = t.indexOf('[/accent]');
    if (a === -1 || z < a) return [{ tekst: t, accent: false }];
    var uit = [];
    if (a > 0) uit.push({ tekst: t.slice(0, a), accent: false });
    uit.push({ tekst: t.slice(a + 8, z), accent: true });
    if (z + 9 < t.length) uit.push({ tekst: t.slice(z + 9), accent: false });
    return uit;
  }

  function formatEuro(centen) {
    var e = Math.floor(centen / 100), c = String(centen % 100).padStart(2, '0');
    return '€' + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + c;
  }

  return { maakSleutel: maakSleutel, normMaat: normMaat, waardenVan: waardenVan, bouwMatrix: bouwMatrix, vindVariant: vindVariant, volgorde: volgorde,
    beschikbaarheid: beschikbaarheid, dichtstbijzijnde: dichtstbijzijnde, bespaar: bespaar,
    bundelKeuze: bundelKeuze, losseSom: losseSom, formatEuro: formatEuro, galerijKeuze: galerijKeuze,
    matenOpOppervlak: matenOpOppervlak, setStoelen: setStoelen, setBladen: setBladen, setBundel: setBundel,
    setMaten: setMaten, setBureauStart: setBureauStart, setVariant: setVariant, setPrijs: setPrijs,
    maxBespaarProcent: maxBespaarProcent, accentDelen: accentDelen, normSleutel: normSleutel, beeldOpMaat: beeldOpMaat };
});
